<template>
  <GridComponent
    id="managementList"
    ref="_grid"
    :data-source="_dataManager"
    :allow-paging="true"
    width="auto"
    :allow-reordering="true"
    :allow-resizing="true"
    :show-column-menu="false"
    :allow-text-wrap="true"
    :row-selected="onRowSelected"
    :row-deselected="onRowDeselected"
    :page-settings="_pageSettings"
    :selection-settings="selectionOptions"
  >
    <ColumnsDirective>
      <ColumnDirective
        type="checkbox"
        width="45"
      />

      <ColumnDirective
        field="cancelationStatusDescription"
        header-text="status"
        :auto-fit="true"
      />
      <ColumnDirective
        field="insuranceNumber"
        header-text="VR-Nummer"
        :auto-fit="true"
      />
      <ColumnDirective
        field="cancelationRequestDate"
        header-text="Angefragt am"
        format="dd.MM.yyyy HH:mm"
        type="DateTime"
        :auto-fit="true"
      />
      <ColumnDirective
        field="cancelationRequestByPersonName"
        header-text="Angefragt von"
        :auto-fit="true"
      />
    </ColumnsDirective>
  </GridComponent>
</template>

<script setup lang="ts">
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import {Api} from "@/shared/services/api";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import {ref} from "vue";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import InsuranceCancelation from "@/shared/model/InsuranceCancelation";
import {SelectionSettingsModel} from "@syncfusion/ej2-grids/src/grid/base/grid-model";
import {useNavigationStore} from "@/modules/Navigation/store";

interface Props {
  selected?: (array: InsuranceCancelation[]) => void;
}

const props = withDefaults(defineProps<Props>(), {
      selected: undefined
    }
)
const _url = Api.baseUrl + '/InsuranceCancelationList';
const _adaptor = new CustomAdaptor()
const _grid = ref<InstanceType<typeof GridComponent> | null>(null)
const _navigationStore = useNavigationStore()
const _pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}
const selectionOptions: SelectionSettingsModel = {type: 'Multiple', enableSimpleMultiRowSelection: true}


const _dataManager = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})

const _emit = defineEmits<{ (e: 'selected', insuranceCancelation?: InsuranceCancelation): void }>()

function onRowSelected(args: any) {
  _navigationStore.currentInsuranceCancelationId = args.data.id;
  _emit("selected", args.data as InsuranceCancelation)
  onSelected()
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _emit("selected", undefined)
  onSelected()
}

function onSelected() {
  if (props.selected) {
    const list = _grid.value?.getSelectedRecords()?.map(t => t as InsuranceCancelation);
    props.selected(list ?? [])
  }
}

function refresh() {
  _grid.value?.refresh()
}


defineExpose({
  adaptor: _adaptor, refresh
})
</script>

<style scoped>

</style>